


import { ModalDialog, ModalService } from './base/shared/modal/modal.service';
import { PreventShrinkService } from './base/services/prevent-shrink.service';
import { LanguageService } from './base/services/language.service';
import { WideFormatService } from './base/services/wide-format.service';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AuthService } from './base/services/auth.service';
import { environment } from 'src/environments/environment';
import { ModalComponent } from './base/shared/modal/modal.component';
import { ToastsComponent } from './base/toasts/toasts.component';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { SpinnerComponent } from './base/spinner/spinner.component';
import { NgClass, NgIf } from '@angular/common';
import { NavigationComponent } from './base/navigation/navigation.component';
import { API_BASE_URL } from './base/models/models.swagger.generated';
import { filter } from 'rxjs/operators';
import { loginPageName, setPasswordPageName, forgotPasswordPageName, publicPrivacyPolicyPageName, deleteAccountPageName } from './core/routing/page-names';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NavigationComponent, NgClass, NgIf, SpinnerComponent, RouterOutlet, ToastsComponent, ModalComponent]
})
export class AppComponent {
  public showNavigation = true;
  public isSidebarExpanded = true;

  public get useWideFormat() {
    return this.wideFormatService.useWideFormat;
  }

  public get noShrink() {
    return this.preventShrinkService.preventShrink;
  }

  private timeoutWarning: ModalDialog;

  constructor(private translate: TranslateService,
    private keepAlive: Keepalive,
    private idle: Idle,
    private modalService: ModalService,
    private authService: AuthService,
    private languageService: LanguageService,
    private wideFormatService: WideFormatService,
    private preventShrinkService: PreventShrinkService,
    private router: Router) {

    this.languageService.init();


    this.configureIdle();
    this.configureKeepAlive();
    this.setupRouteListener();
  }


  public onSidebarToggled(isExpanded: boolean): void {
    this.isSidebarExpanded = isExpanded;
  }

  private configureKeepAlive() {
    this.keepAlive.interval(30);
    this.keepAlive.onPing.subscribe(() => {
      this.authService.updateActivityTimeStamp();
    });
  }

  private configureIdle() {
    this.idle.setIdle(environment.idleTimeoutInSeconds);
    this.idle.setTimeout(60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      const dialog = this.timeoutWarning;
      this.modalService.closeDialog(dialog);
      this.timeoutWarning = null;
    });

    this.idle.onTimeout.subscribe(() => {
      this.modalService.closeDialog(this.timeoutWarning);
      this.timeoutWarning = null;
      this.authService.logout();
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      const message = this.translate.instant('i18n.core.modal.idle.message', { params: countdown });
      if (!this.timeoutWarning) {
        if (!this.idle.isIdling()) {
          return;
        }
        this.timeoutWarning = this.modalService.showMessageDialog('i18n.core.modal.idle.title', message);
      } else {
        this.timeoutWarning.message = this.translate.instant('i18n.core.modal.idle.message', { params: countdown });
      }
    });
  }

  private setupRouteListener() {
    const pagesWithoutNavigation = [
      loginPageName,
      setPasswordPageName,
      forgotPasswordPageName,
      publicPrivacyPolicyPageName,
      deleteAccountPageName
    ];

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.showNavigation = !pagesWithoutNavigation.some(page => event.url.includes('/' + page));
    });
  }
}